export const PARENT_ACCESS_TOKEN_KEY = '50b43c58-39ea-460c-9c27-2734f53dc56c';
export const CLIENT_ACCESS_TOKEN_KEY = 'd9c8c502-9ac9-4b00-8a3f-a60f04943815';
export const ADMIN_ACCESS_TOKEN_KEY = '8495e34b-e9c8-428a-aae9-f27e090be3ae';
